import numeral from "numeral";

export const formatCurrency = (numberToFormat) => {
  return numeral(numberToFormat).format("$0,0.00");
};
